import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import authReducer from './store/reducers/auth'
import profileReducer from "./store/reducers/profile"
import reportReducer from "./store/reducers/reports"
import * as actionTypes from "./store/actions/actionTypes"


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers({
    auth: authReducer,
    profile: profileReducer,
    reports: reportReducer
});

const rootReducer = (state, action) => {
    // alert(action.type)
    if (action.type === actionTypes.REPORT_FLUSH) {
        return appReducer(undefined, action)
    }

    return appReducer(state, action)
}

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));


ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
